import { render, staticRenderFns } from "./MostLearn.vue?vue&type=template&id=ee650b9a"
import script from "./MostLearn.vue?vue&type=script&lang=js"
export * from "./MostLearn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports